import { useRef, useCallback, useState, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";

const Reactsignatureconvas = (props) => {
  const padRef = useRef(null);
  const [canvas, setCanvas] = useState("");
  const [canvasVisibility, setCanvasVisibility] = useState(false);

  const clearSignatureCanvas = useCallback(() => {
    padRef?.current?.clear();
    setCanvas(undefined);
    setCanvasVisibility(false);
  }, []);

  const handleGetCanvas = useCallback(() => {
    const canvas = padRef?.current?.toDataURL();
    console.log(canvas);
    setCanvas(canvas);
    setCanvasVisibility(true);
    props.signatuterfn(canvas);
  }, []);

  return (
    <div className="">
      {!canvasVisibility && (
        <div className="d-flex justify-content-center">
          <div className="">
            <SignatureCanvas
              penColor="blue"
              dotSize={2}
              ref={padRef}
              canvasProps={{
                width: 380,
                height: 180,
              }}
            />
            <div className=" text-center">
              <button className="btn " onClick={clearSignatureCanvas}>
                Clear
              </button>
              <button className="btn" onClick={handleGetCanvas}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="d-flex justify-content-center">
        <div className="  mt-1">
          {canvasVisibility && <img src={canvas} alt="signature" />}
          <div className="bg-light text-center">
            {canvasVisibility && (
              <button className="btn " onClick={clearSignatureCanvas}>
                Redo
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reactsignatureconvas;
